var Portal;
(function(Portal) {
    Portal["CompanyPortal"] = "company_portal";
    Portal["Experience"] = "experience";
    Portal["Onsite"] = "onsite-app";
})(Portal || (Portal = {}));
export default Portal;
